export const LOGIN_ROUTE_NAME = Symbol('login');
export const TRANSLATION_GROUP_LOGIN = Symbol('login');
